<div class="">
    <p-dialog header="Change Password" class="actions-dialog" [modal]="true" [closable]="false" [(visible)]="displayDialog">
        <change-password-form #changePasswordForm [userId]="userId" [showSaveButton]="false" [styleClass]="'mx-3'" (onSaved)="close()"></change-password-form>
        <p-footer>
            <button type="submit" pButton label="Save" class="p-button-primary" icon="fa fa-save" (click)="submit()" [disabled]="!changePasswordForm.isValid()"></button>
            <button type="cancel" pButton label="Cancel" class="edge-no-button" icon="fa fa-times" (click)="close()"></button>
        </p-footer>
    </p-dialog>
</div>